import {
  GET_PRINT_ERRORS,
  GET_PRINT_ERRORS_ERROR,
  PRINT_ERRORS_LOADING,
  RESOLVE_PRINT_ERROR,
  PENDING_PRINT_ERRORS,
} from "../actions/types";

const initialState = {
  errors: [],
  loading: true,
  pendingCount: 0,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PRINT_ERRORS:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case RESOLVE_PRINT_ERROR:
      // The resolve response has no printerName/location/order, so the row keeps its own
      return {
        ...state,
        errors: state.errors.map((item) =>
          item._id === payload._id
            ? {
                ...payload,
                printerName: item.printerName,
                location: item.location,
                order: item.order,
              }
            : item
        ),
      };
    case GET_PRINT_ERRORS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case PRINT_ERRORS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case PENDING_PRINT_ERRORS:
      return {
        ...state,
        pendingCount: payload,
      };
    default:
      return state;
  }
}
